import _ from "lodash";

export default function Validation() {

    /********************************************************/
    if (Validation.prototype._singletonInstance) return Validation.prototype._singletonInstance;
    Validation.prototype._singletonInstance = this;
    /********************************************************/

    const validationMethods = {
        required: (field, value) => {
            if (!value.toString().trim().length) {
                return `This ${field} field is required.`
            }
        },
        email: (field, value) => {
            const invalidDomains = ['hotmail.com', 'googlemail.com', 'live.co.uk', 'msn.co.uk', 'btinternet.co.uk',
                'btopenworld.com', 'talktalk.net', 'hotmail.co.uk', 'gmail.com', 'yahoo.com', 'yahoo.co.uk',
                'outlook.com', 'outlook.co.uk', 'sisense.com', 'looker.com', 'phocassoftware.com', 'datapine.co.uk',
                'yellowfinbi.com', 'qlik.com', 'izenda.com', 'microsoft.com', 'tableau.com', 'jinfonet.com',
                'xapsys.co.uk', 'sap.com', 'sas.com', 'infor.com', 'ibm.com', 'domo.com', 'oracle.com',
                'microstrategy.com', 'boldbi.com', 'cumul.io', 'thoughtspot.com', 'icloud.com'];

            const trimmedValue = value.toString().trim();
            const emailDomain = trimmedValue.substr(trimmedValue.search('@') + 1);
            const filter = /^\S+@\S+\.\S+$/;
            if (_.indexOf(invalidDomains, emailDomain) > -1) {
                return 'Please use a business email.';
            } else if (!filter.test(value.toString().trim())) {
                return 'Please enter a valid email.';
            }
        },
        confirmPassword: (field, value) => {
            const password = document.getElementById('password');
            if (value !== password.value) {
                return "Passwords do not match."
            }
        },
        password: (field, value) => {
            const filter = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$*.{}?"!@#%&/,><':;|_~`^\][)(]).{8,}/;
            const confirmPassword = document.getElementById('confirmPassword');
            if (confirmPassword.value.length > 0 && confirmPassword.value !== value) {
                return 'Passwords do not match.'
            }
            if (!filter.test(value)) {
                return 'Your password must be at least 8 characters and contain an upper case character, a lower case character, a number and a special character';
            }


        }
    };

    this.validateForm = function (form) {
        const loginForm = document.getElementById(form);
        return loginForm.querySelectorAll('[validations]');
    };

    this.runValidationRules = function (element, errors) {
        const target = element;
        const field = target.name;
        const value = target.value;
        let validations = element.getAttribute('validations');
        validations = validations.split(',');

        for (let validation of validations) {
            validation = validation.split(':');
            const rule = validation[0];
            const error = validationMethods[rule](field, value);
            errors[field] = errors[field] || {};
            if (error) {
                errors[field][rule] = error;
            } else {
                if (_.isEmpty(errors[field])) {
                    delete errors[field];
                } else {
                    delete errors[field][rule];
                }
            }
        }
        return errors;
    };
}